import { render } from "./ManageVisit.vue?vue&type=template&id=605f8aaa&scoped=true"
import script from "./MangeVisit.js?vue&type=script&lang=js"
export * from "./MangeVisit.js?vue&type=script&lang=js"

import "./ManageVisit.vue?vue&type=style&index=0&id=605f8aaa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605f8aaa"]])

export default __exports__